const breakpoint = {
  xs: 0,
  md: 768,
  lg: 992,
  xlg: 1250,
};

export const spacing = {
  // media-query uses min-width
  breakpoint,

  breakpoints: [breakpoint.xs, breakpoint.md, breakpoint.lg, breakpoint.xlg],

  margin: {
    // ?
    // Scale
    '0': '0',

    '2': '0.125rem',

    '4': '0.25rem',

    '6': '0.375rem',

    '8': '0.5rem',

    '10': '0.625rem',

    '12': '0.75rem',

    '14': '0.875rem',

    '16': '1rem',

    '18': '1.125rem',

    '20': '1.25rem',

    '30': '1.875rem',

    '40': '2.5rem',

    '50': '3.125rem',

    // ?
    lg: '3.75rem',

    // ?
    md: '2.5rem',

    // Fora specific
    sm: '1.25rem',
    // ...
  },

  padding: {
    // ?
    // Scale
    '0': '0',

    '2': '0.125rem',

    '4': '0.25rem',

    '6': '0.375rem',

    '8': '0.5rem',

    '10': '0.625rem',

    '12': '0.75rem',

    '14': '0.875rem',

    '16': '1rem',

    '18': '1.125rem',

    '20': '1.25rem',

    '30': '1.875rem',

    '40': '2.5rem',

    '50': '3.125rem',

    // ?
    lg: '3.75rem',

    // ?
    md: '2.5rem',

    // Fora specific
    sm: '1.25rem',
    // ...
  },
};
